import React from 'react';
import CourseGrid from '../components/CourseGrid';

const CoursePage = () => <CourseGrid />;

export default CoursePage;
